import EbisPagination from './EbisPagination';

export default EbisPagination;
